import { render, staticRenderFns } from "./CounselingQuestion.vue?vue&type=template&id=f3bb524e&"
import script from "./CounselingQuestion.vue?vue&type=script&lang=js&"
export * from "./CounselingQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports